var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDelete2Small(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.094,
    height: 13.735,
    viewBox: "0 0 12.094 13.735",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_76194",
    "data-name": "Group 76194",
    transform: "translate(-657.764 -237.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78554",
    "data-name": "Path 78554",
    d: "M2141.182,345.286a.111.111,0,0,0-.112.052,2.5,2.5,0,0,0-.263.49l-.012.027-.685,1.6h-2.362a.34.34,0,0,0-.34.339v.926a.34.34,0,0,0,.34.34h.776l.57,8.037v.02a.58.58,0,0,0,.58.58h6.235a.58.58,0,0,0,.58-.58v-.04l.568-8.017h.776a.34.34,0,0,0,.34-.34v-.926a.34.34,0,0,0-.34-.339h-2.36l-.681-1.6c-.223-.523-.294-.561-.385-.561h-3.226m0-.564h3.226c.5,0,.7.42.9.9l.536,1.262h1.987a.9.9,0,0,1,.9.9v.926a.9.9,0,0,1-.9.9h-.25l-.531,7.493a1.143,1.143,0,0,1-1.144,1.144h-6.235a1.143,1.143,0,0,1-1.144-1.144l-.532-7.493h-.25a.9.9,0,0,1-.9-.9v-.926a.9.9,0,0,1,.9-.9h1.99l.541-1.262C2140.513,345.117,2140.684,344.722,2141.182,344.722Z",
    transform: "translate(-1478.98 -106.722)",
    fill: "#f45e29",
    stroke: "#f45e29",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_75500",
    "data-name": "Group 75500",
    transform: "translate(662.276 244.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_863",
    "data-name": "Line 863",
    d: "M-.2,4.634a.294.294,0,0,1-.3-.285V-.215A.294.294,0,0,1-.2-.5a.294.294,0,0,1,.3.285V4.348A.294.294,0,0,1-.2,4.634Z",
    transform: "translate(0.5 0.5)",
    fill: "#f45e29",
    stroke: "#f45e29",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_864",
    "data-name": "Line 864",
    d: "M-.2,4.634a.294.294,0,0,1-.3-.285V-.215A.294.294,0,0,1-.2-.5a.294.294,0,0,1,.3.285V4.348A.294.294,0,0,1-.2,4.634Z",
    transform: "translate(2.914 0.5)",
    fill: "#f45e29",
    stroke: "#f45e29",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_78555",
    "data-name": "Path 78555",
    d: "M-183.38-15396.922h-9.1v-.6h9.1Z",
    transform: "translate(851.712 15639.85)",
    fill: "#f45e29",
    stroke: "#f45e29",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete2Small);
export default __webpack_public_path__ + "static/media/icon-delete2-small.10bf115a.svg";
export { ForwardRef as ReactComponent };